(() => {
	if (window.PartifySupportSchedule) {
		window.PartifySupportSchedule.refresh();
		window.dispatchEvent(new Event("partify:support-schedule-ready"));
		return;
	}

	// Shared support-desk hours are interpreted in Eastern time for every storefront visitor.
	const BUSINESS_TIME_ZONE = "America/New_York";
	const BUSINESS_HOURS = Object.freeze({
		Mon: Object.freeze({ opensAt: 8 * 60, closesAt: 19 * 60 }),
		Tue: Object.freeze({ opensAt: 8 * 60, closesAt: 19 * 60 }),
		Wed: Object.freeze({ opensAt: 8 * 60, closesAt: 19 * 60 }),
		Thu: Object.freeze({ opensAt: 8 * 60, closesAt: 19 * 60 }),
		Fri: Object.freeze({ opensAt: 8 * 60, closesAt: 18 * 60 }),
	});
	const businessTimeFormatter = new Intl.DateTimeFormat("en-US", {
		timeZone: BUSINESS_TIME_ZONE,
		weekday: "short",
		hour: "2-digit",
		minute: "2-digit",
		hourCycle: "h23",
	});
	let refreshTimer;

	function formatBusinessHoursLabel(locale = "en-US") {
		try {
			const weekdays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
			const weekdayFormatter = new Intl.DateTimeFormat(locale || "en-US", {
				weekday: "short",
				timeZone: "UTC",
			});
			const formatWeekday = (index) =>
				weekdayFormatter.format(new Date(Date.UTC(2024, 0, 7 + index, 12)));
			const formatTime = (minutes) =>
				new Intl.DateTimeFormat(locale || "en-US", {
					hour: "numeric",
					...(minutes % 60 ? { minute: "2-digit" } : {}),
					hour12: true,
					timeZone: "UTC",
				}).format(
					new Date(Date.UTC(2024, 0, 7, Math.floor(minutes / 60), minutes % 60)),
				);
			const ranges = weekdays.reduce((result, weekday, index) => {
				const hours = BUSINESS_HOURS[weekday];
				if (!hours) return result;
				const previous = result[result.length - 1];
				if (
					previous &&
					previous.end === index - 1 &&
					previous.opensAt === hours.opensAt &&
					previous.closesAt === hours.closesAt
				) {
					previous.end = index;
				} else {
					result.push({ start: index, end: index, ...hours });
				}
				return result;
			}, []);
			return `${ranges
				.map((range) => {
					const days =
						range.start === range.end
							? formatWeekday(range.start)
							: `${formatWeekday(range.start)}\u2013${formatWeekday(range.end)}`;
					return `${days} ${formatTime(range.opensAt)}\u2013${formatTime(
						range.closesAt,
					)}`;
				})
				.join(" \u00b7 ")} ET`;
		} catch (error) {
			return locale === "en-US" ? "" : formatBusinessHoursLabel("en-US");
		}
	}

	function businessTimeAt(date) {
		return businessTimeFormatter.formatToParts(date).reduce(
			(time, part) => {
				if (part.type === "weekday") time.weekday = part.value;
				if (part.type === "hour") time.hour = Number(part.value);
				if (part.type === "minute") time.minute = Number(part.value);
				return time;
			},
			{ weekday: "", hour: 0, minute: 0 },
		);
	}

	function isOpenDuringBusinessTime(businessTime) {
		const hours = BUSINESS_HOURS[businessTime.weekday];
		if (!hours) return false;

		const minuteOfDay = businessTime.hour * 60 + businessTime.minute;
		return minuteOfDay >= hours.opensAt && minuteOfDay < hours.closesAt;
	}

	function isOpenAt(date = new Date()) {
		return isOpenDuringBusinessTime(businessTimeAt(date));
	}

	function refresh(date = new Date()) {
		const businessTime = businessTimeAt(date);
		const isOpen = isOpenDuringBusinessTime(businessTime);
		document.querySelectorAll("[data-support-specialist]").forEach((specialist) => {
			specialist.toggleAttribute("hidden", !isOpen);
		});
	}

	function scheduleRefresh() {
		window.clearTimeout(refreshTimer);
		const nextMinuteDelay = 60000 - (Date.now() % 60000) + 50;
		refreshTimer = window.setTimeout(() => {
			refresh();
			scheduleRefresh();
		}, nextMinuteDelay);
	}

	function start() {
		refresh();
		scheduleRefresh();
	}

	window.PartifySupportSchedule = Object.freeze({
		hoursLabel: formatBusinessHoursLabel(document.documentElement.lang),
		isOpenAt,
		refresh,
		timeZone: BUSINESS_TIME_ZONE,
	});
	window.dispatchEvent(new Event("partify:support-schedule-ready"));

	document.addEventListener("visibilitychange", () => {
		if (document.visibilityState === "visible") refresh();
	});
	window.addEventListener("pageshow", () => refresh());

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start, { once: true });
	} else {
		start();
	}
})();
